module.exports = __webpack_public_path__ + "img/FeatueBG.5c16087e.jpg";